import { Header } from './appCommon.jsx';

// Web stand-in for app/src/screens/WatchAppHelp/Topic.js, the page one Watch App
// help topic is told on. The app's topic screens (ZoneScreen, TemperatureScreen…)
// are rendered in place on the web and import Topic relatively; plugins/appShims.js
// answers that import with this module, so the topics keep their copy, their
// step structure and their illustrations from the app while the page around them
// is a web page: the web header (back to the topic list, focused h1, page title),
// the copy, the illustration centred in the column, and the step bar if there is
// one. Same props as the app's Topic: title, body, diagram, footer.
export default function Topic({ title, body, diagram, footer }) {
  return (
    <>
      <Header title={title} subText="How to use your smartwatch app" />
      <div className="watch-topic">
        {/* The app sets this copy small (its xs size) to leave the phone screen
            to the drawing; a desktop column has the room, so it reads at the
            body size here. */}
        {body ? <p className="watch-topic__body">{body}</p> : null}
        <div className="watch-topic__diagram">{diagram}</div>
      </div>
      {footer}
    </>
  );
}
